'use client';

import { convertBemToCamel } from '@/third-party-templates/EnercityEasyGo/helpers';
import clsx from 'clsx';
import { CSSProperties, PropsWithChildren } from 'react';
import { CSS_VAR_COLOR } from '../../constants/css';
import { Alignment } from '../../types/alignment';
import styles from './Headline.module.scss';

export type HeadlineProps = PropsWithChildren<{
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  align?: Alignment;
  color?: 'black' | 'white' | 'gradient';
  className?: string;
}>;

export const Headline = ({
  level = 2,
  align = 'center',
  children,
  color = 'black',
  className,
}: HeadlineProps) => {
  const Tag = `h${level}` as keyof JSX.IntrinsicElements;
  const classes = clsx(
    styles.base,
    styles[align],
    color && styles[convertBemToCamel(`color-${color}`)],
    className
  );
  const style = { [CSS_VAR_COLOR]: color } as CSSProperties;

  return (
    <div className={classes}>
      <Tag style={style}>
        <strong>{children}</strong>
      </Tag>
    </div>
  );
};
